import { Container, Icon } from 'roadie-ui'
import { PanelTitle } from 'components/layout/Panel'
import ButtonLink from '../Button/ButtonLink'

type BreadcrumbItem = {
  label: string
  linkTo?: string // optional — no link on last item
}

type BreadcrumbProps = {
  items: BreadcrumbItem[]
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <Container.Grid $gridAutoFlow="column" $alignItems="center" $gridGap="0.7rem" $justifyContent="start">
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <>
            <Container.GridItem>
              {item.linkTo ? (
                <ButtonLink variant="tertiary" id={`breadcrumb-${index}`} to={item.linkTo}>
                  <PanelTitle color="rgb(0, 187, 187)">{item.label}</PanelTitle>
                </ButtonLink>
              ) : (
                <PanelTitle paddingLeft="0">{item.label.toUpperCase()}</PanelTitle>
              )}
            </Container.GridItem>

            {!isLast && (
              <Container.GridItem>
                <Icon.ChevronRight $color="primary-base" $width="1.2rem" />
              </Container.GridItem>
            )}
          </>
        )
      })}
    </Container.Grid>
  )
}
